import React from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

import{BrowserRouter as Router,HashRouter,Route,Switch} from "react-router-dom";
import MainApp from './main';

import './App.css'
function App() {
  return (
    <div className="App">
      <HashRouter>
        <MainApp/>
      </HashRouter>
    </div>
  );
}

export default App;